import { RootState } from '../../reducers'

export function getLaunchHostingError(state: RootState): string | undefined {
  return state?.launchHosting?.launchHostingError || state.socketServer.roomState?.hostingError
}

export function isHostingLaunchingSelector(state: RootState): boolean {
  return state.launchHosting.launchHostingLoading
}
